import { ExternalPlatformCredentialsQuery } from './external-platform-credentials-query';
import { ShopDetailsQuery } from '../../../network/shop-details-query';
import { ImportPlatformDataMutation } from './import-platform-data-mutation';
export var endpoints = {
    shopDetailsQuery: new ShopDetailsQuery(),
    externalPlatformCredentialsQuery: new ExternalPlatformCredentialsQuery(),
    importPlatformDataMutation: new ImportPlatformDataMutation(),
};
